/* rep.js — Kit REP (réplica NubeStep). Maneja: galería, countdown,
   selector de Talla + Color (resuelve variante) y pack de cantidad. */

document.addEventListener('DOMContentLoaded', () => {
  repInitVariantPicker();
  repInitBundle();
  repInitCountdown();
});

/* ── Estado compartido ─────────────────────────────────────────── */
const repState = { size: null, color: null, qty: 1 };

function repVariantMap() {
  const el = document.getElementById('rep-variant-data');
  if (!el) return [];
  try { return JSON.parse(el.textContent); } catch (e) { return []; }
}

function repFindVariant() {
  const map = repVariantMap();
  // requiere color sólo si el producto tiene colores
  const hasColor = map.some(v => v.color);
  return map.find(v =>
    (!repState.size || v.size === repState.size) &&
    (!hasColor || !repState.color || v.color === repState.color)
  ) || map[0];
}

function repMoney(cents) {
  // formato MXN simple: $1,098.00  (los cents vienen del .price de Shopify)
  const n = (cents / 100);
  return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function repSync() {
  const v = repFindVariant();
  if (!v) return;
  const input = document.getElementById('rep-variant-input');
  if (input) input.value = v.id;

  // total del pack = precio variante × qty
  const total = v.price * repState.qty;
  document.querySelectorAll('.rep-bundle').forEach(b => {
    const q = parseInt(b.dataset.qty || '1', 10);
    const unit = v.price * q;
    const pe = b.querySelector('.gc-bundle__price');
    if (pe) pe.textContent = repMoney(unit);
    if (v.compare && v.compare > v.price) {
      const ce = b.querySelector('.gc-bundle__compare');
      if (ce) ce.textContent = repMoney(v.compare * q);
    }
  });

  const atc = document.getElementById('gc-atc-btn');
  if (atc) atc.textContent = 'AGREGAR AL CARRITO';

  // aviso de talla faltante
  const warn = document.getElementById('rep-size-warn');
  if (warn) warn.style.display = repState.size ? 'none' : '';
}

/* ── Selector de Talla + Color ─────────────────────────────────── */
function repInitVariantPicker() {
  document.querySelectorAll('.rep-opt[data-opt="size"]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.rep-opt[data-opt="size"]').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      repState.size = btn.dataset.value;
      repSync();
    });
  });
  document.querySelectorAll('.rep-opt[data-opt="color"]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.rep-opt[data-opt="color"]').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      repState.color = btn.dataset.value;
      repSync();
    });
  });
  // Talla por desplegable (<select>)
  const sizeSelect = document.getElementById('rep-size-select');
  if (sizeSelect) {
    sizeSelect.addEventListener('change', () => {
      repState.size = sizeSelect.value || null;
      repSync();
    });
  }
  // default color = primero disponible (talla la elige el usuario, fiel a CloudSole)
  const firstColor = document.querySelector('.rep-opt[data-opt="color"]');
  if (firstColor) { firstColor.classList.add('selected'); repState.color = firstColor.dataset.value; }
  repSync();
}

/* ── Bundle de cantidad (packs) ────────────────────────────────── */
function repInitBundle() {
  const bundles = document.querySelectorAll('.rep-bundle');
  bundles.forEach(bundle => {
    bundle.addEventListener('click', () => {
      bundles.forEach(b => b.classList.remove('selected'));
      bundle.classList.add('selected');
      const radio = bundle.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      repState.qty = parseInt(bundle.dataset.qty || '1', 10);
      const qi = document.getElementById('rep-qty-input');
      if (qi) qi.value = repState.qty;
      repSync();
    });
  });
  // selecciona el marcado por defecto (forloop.first)
  const def = document.querySelector('.rep-bundle.selected') || bundles[0];
  if (def) { repState.qty = parseInt(def.dataset.qty || '1', 10); }
}

/* ── Guardia: no permitir comprar sin talla ────────────────────── */
function repGuardSize(e) {
  if (!repState.size) {
    e.preventDefault();
    const warn = document.getElementById('rep-size-warn');
    if (warn) { warn.style.display = ''; warn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return false;
  }
  return true;
}

/* ── Countdown (15 min por sesión) ─────────────────────────────── */
function repInitCountdown() {
  const el = document.getElementById('gc-countdown');
  if (!el) return;
  const KEY = 'rep_cd_end';
  let end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
  if (!end || end < Date.now()) {
    end = Date.now() + 15 * 60 * 1000;
    sessionStorage.setItem(KEY, end);
  }
  function tick() {
    const rem = Math.max(0, end - Date.now());
    const m = Math.floor(rem / 60000);
    const s = Math.floor((rem % 60000) / 1000);
    el.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    if (rem > 0) requestAnimationFrame(tick);
    else el.closest('.gc-hero__urgency')?.remove();
  }
  tick();
}

/* ── Galería ───────────────────────────────────────────────────── */
function repSetImage(url, thumbEl) {
  const mainImg = document.getElementById('gc-main-img');
  if (mainImg) {
    mainImg.style.opacity = '0';
    mainImg.src = url;
    mainImg.onload = () => { mainImg.style.opacity = '1'; };
    mainImg.style.transition = 'opacity .2s';
  }
  document.querySelectorAll('.gc-hero__thumb').forEach(t => t.classList.remove('active'));
  if (thumbEl) thumbEl.classList.add('active');
}
